module.exports = __webpack_public_path__ + "static/media/img3.9ba57568.svg";